import { DomainDto } from '../../dtos/domain'

/**
 * Determines whether the Catalog navigation item should be displayed in the sidebar.
 *
 * @param domain - The domain DTO to check, may be null
 * @returns true if the domain has a configured ecommConfig.itemType, false otherwise
 *
 * Validates: Requirements 1.1, 1.2
 */
export function shouldShowCatalogNavItem(domain: DomainDto | null): boolean {
    if (!domain) {
        return false
    }

    const itemType = domain.ecommConfig?.itemType

    // Check if itemType is defined and non-empty
    return itemType !== undefined && itemType !== null
}

/**
 * Formats an event location from city, region, and country parts.
 *
 * @param city - The city name (optional)
 * @param region - The region/state name (optional)
 * @param country - The country name (optional)
 * @returns Formatted location string like "Austin, TX, US", or empty string if all parts are empty
 *
 * Validates: Requirements 12.1, 12.2, 12.3
 */
export function formatEventLocation(city?: string, region?: string, country?: string): string {
    const parts = [city, region, country].filter((part) => part !== undefined && part !== null && part !== '')
    return parts.join(', ')
}
